<ng-container *ngIf="count > 0">
  <svg
    *ngFor="let star of stars"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
  >
    <path
      d="M9.11103 0.141357L11.0845 6.2209H17.4709L12.3042 9.97827L14.2777 16.0578L9.11103 12.3005L3.94433 16.0578L5.91784 9.97827L0.751142 6.2209H7.13753L9.11103 0.141357Z"
      fill="#FAC644"
    />
  </svg>
  <div class="ms-2">{{ count }} reviews</div>
</ng-container>
